// src/plugins/i18n.js
import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    greeting: "Hi, I'm Takanori Fujiki",
    subtitle: "Front-end Developer & Growth Engineer",
    aboutTitle: "About Me",
    aboutContent: "I build modern, responsive web applications and leverage data-driven insights to help businesses grow.",
    viewProjects: "View All Projects",
    linkProjects: "Projects",
    linkAbout: "About",
    bioText1: "Hi, I'm Takanori Fujiki — a front-end developer with a passion for clean code, elegant UI, and solving real-world problems through web technologies.",
    bioText2: "After gaining strong communication skills and top sales performance at Apple Inc, I transitioned into the tech world, where I’ve built modern web applications using Vue.js, React, Python, and MySQL. While working with international teams in Canada, I led frontend development projects, integrated Stripe payments, and streamlined operations with automation scripts. I also bring project management experience, from client negotiation to final delivery.",
    bioText3: "I'm a reliable, self-driven, and flexible team player who thrives on continuous learning. As I evolve from a front-end specialist to a growth engineer, I am expanding my expertise into web analytics and data-driven decision-making to boost user engagement and product growth. My goal is to create digital experiences that are not only beautiful but also functional and scalable. If you're facing challenges in design, development, or digital strategy — I'd love to help. Let’s build something great together.",
    relatedProjectsHeading: "Related Projects",
    projectRole: "Role",
    projectTool: "Tools & Technologies",
    projectUrl: "Project URL",
    projectChallenge: "Challenges",
    aboutTechStack: "Tech Stack",
    aboutAdobe: "Adobe Creative Cloud",
    aboutCareer: "Career Timeline",
    CareerName1: "Retail Solution Consultant / Apple Japan",
    CareerText1: "Achieved top national sales in MacBook category while developing strong communication, sales, and customer support skills.",
    CareerName2: "Intern / Goopter Holdings Ltd.",
    CareerText2: "Contributed to web design and UI/UX improvements during internship at a startup providing ordering solutions for restaurants.",
    CareerName3: "Data Analyst Intern / New Line Hose & Fittings",
    CareerText3: "Supported inventory and order data management through automation tools and dashboards built with Python and MySQL.",
    CareerName4: "Front-end Developer / Androvega Software Ltd.",
    CareerText4: "Led UI/UX and frontend development for B2B software products using Vue.js and React in an international team.",
    CareerName5: "Growth Engineer / Freelance",
    CareerText5: "Blending frontend development with data analytics to help startups and web products grow through insights, tracking, and conversion optimization.",
    aboutMessage: "Let's build something great together.",
    aboutMessage2: "Feel free to reach out if you'd like to collaborate on a project or just say hello.",
    aboutContact: "Contact me",
    linkContact: "Contact",
    titleResume: "Resume",
    selectType: "Select Type",
    langEn: "EN",
    langJp: "JP",
    contactTitle: "Contact Details",
    contactFormTitle: "Contact Form",
    sendMessage: "Send Message",
    nameTitle: "Name",
    emailTitle: "Email",
    subjectTitle: "Subject",
    messageTitle: "Message",
    formErrorName: "Please enter your name.",
    formErrorEmail: "Please enter your email address.",
    formErrorEmailFormat: "Please enter a valid email address.",
    formErrorSubject: "Please enter a subject.",
    formErrorMessage: "Please enter your message.",
    formSubmitSuccess: "Message sent successfully!",
    formSubmitError: "Failed to send message. Please try again.",
  },
  ja: {
    greeting: "こんにちは、私は藤木俊徳です",
    subtitle: "フロントエンド開発者 / グロースエンジニア",
    aboutTitle: "自己紹介",
    aboutContent: "最新技術でモダンなWebアプリを開発し、データ分析に基づく戦略でビジネスの成長を支援しています。",
    viewProjects: "プロジェクト一覧を見る",
    linkProjects: "プロジェクト",
    linkAbout: "自己紹介",
    linkContact: "お問い合わせ",
    titleResume: "履歴書",
    selectType: "タイプを選択",
    langEn: "英語",
    langJp: "日本語",
    bioText1: "こんにちは、藤木俊徳です。クリーンなコード、エレガントなUI、そして実世界の問題をWeb技術で解決することに情熱を注いでいるフロントエンド開発者です。",
    bioText2: "Apple Ltdでの強力なコミュニケーションスキルとトップセールスパフォーマンスを経て、テクノロジーの世界に転身しました。Vue.js、React、Python、MySQLを使用してモダンなWebアプリケーションを構築しています。カナダで国際チームと協力しながら、フロントエンド開発プロジェクトをリードし、Stripe決済を統合し、自動化スクリプトで業務を効率化しました。また、クライアントとの交渉から最終納品までのプロジェクト管理経験も持っています。",
    bioText3: "私は信頼性が高く、自発的で柔軟なチームプレーヤーであり、継続的な学習を重視しています。フロントエンド開発のスペシャリストから、グロースエンジニアとしてのキャリアへと進化する中で、ユーザー分析やデータに基づいた意思決定を取り入れ、プロダクトの成長と改善を支援しています。私の目標は、美しいだけでなく、実用的かつ拡張性のあるデジタル体験を創ることです。デザイン、開発、またはデジタル戦略に課題を抱えている場合は、ぜひお手伝いさせてください。一緒に素晴らしいものを作りましょう。",
    relatedProjectsHeading: "関連プロジェクト",
    projectRole: "役割",
    projectTool: "使用ツール・技術",
    projectUrl: "プロジェクトURL",
    projectChallenge: "課題",
    aboutTechStack: "技術スタック",
    aboutAdobe: "Adobe Creative Cloud",
    aboutCareer: "キャリアタイムライン",
    CareerName1: "Apple Solution Consultant / Apple Japan 合同会社",
    CareerText1: "MacBook部門で全国トップの売上を達成。接客・提案・営業スキルと高いコミュニケーション力を習得。",
    CareerName2: "インターン / Goopter Holdings Ltd.",
    CareerText2: "飲食店向けソリューションを提供するスタートアップで、WebデザインやUI/UX改善に貢献。",
    CareerName3: "データアナリスト（有給インターン） / New Line Hose & Fittings",
    CareerText3: "PythonとMySQLでダッシュボードや在庫管理ツールを構築し、注文業務の効率化を支援。",
    CareerName4: "フロントエンド開発者 / Androvega Software Ltd.",
    CareerText4: "Vue.jsやReactを用いてB2Bソフトウェアのフロントエンド設計・開発をリード。国際チームでプロジェクトを遂行。",
    CareerName5: "グロースエンジニア / フリーランス",
    CareerText5: "フロントエンド開発とデータ分析を活かして、スタートアップやWebプロダクトの成長を支援。ユーザー行動分析やCV最適化を担当。",
    aboutMessage: "一緒に素晴らしいものを作りましょう。",
    aboutMessage2: "プロジェクトでのコラボレーションや、ただ挨拶をしたい場合は、お気軽にご連絡ください。",
    aboutContact: "お問い合わせ",
    contactTitle: "お問い合わせ",
    contactFormTitle: "お問い合わせフォーム",
    sendMessage: "メッセージを送信",
    nameTitle: "名前",
    emailTitle: "メールアドレス",
    subjectTitle: "件名",
    messageTitle: "メッセージ",
    formErrorName: "お名前を入力してください。",
    formErrorEmail: "メールアドレスを入力してください。",
    formErrorEmailFormat: "正しいメールアドレスを入力してください。",
    formErrorSubject: "件名を入力してください。",
    formErrorMessage: "メッセージを入力してください。",
    formSubmitSuccess: "メッセージが送信されました！",
    formSubmitError: "メッセージの送信に失敗しました。もう一度お試しください。",
  }
}

export const i18n = createI18n({
  legacy: false, // 👈 これを追加！
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'ja',
  messages,
})